import { JOURNEY_STAGES } from '../../chrome.js';
import { Placeholder } from '../../Placeholder.js';
import type { Surface } from '../../router.js';

/**
 * One surface per Experiment stage. They exist so the shell switches from Atlas to
 * Journey on a real route rather than on a flag.
 */
const OWNED: readonly string[] = ['brief', 'explore', 'refine', 'compare', 'export', 'learn'];

const stageSurfaces: readonly Surface[] = JOURNEY_STAGES.filter((stage) => !OWNED.includes(stage.key)).map((stage) => ({
  id: `experiment-${stage.key}`,
  path: `/experiments/:experimentId/${stage.key}`,
  title: stage.label,
  placeholder: true,
  render: (params) => (
    <Placeholder
      eyebrow={`Experiment · ${stage.label}`}
      title={`${stage.label} для ${params.experimentId ?? 'этого Experiment'}`}
      note="Этот этап заполнится своим экраном."
    />
  ),
}));

export const surfaces: readonly Surface[] = stageSurfaces;
